import { makeAutoObservable, runInAction } from "mobx";
import http from "../../../libs/http";
import { OrdersResponse } from "../../../types/order";
import { IAccountSettings } from "../components/AccountSettings";
import { IAccountSettingsResponse } from "../../../types/account";
import { Product } from "../../../types/product";
import appStore from "../../../stores/appStore";

class AccountStore {
  orders?: OrdersResponse;

  favorites?: Product[] = JSON.parse(localStorage.getItem("favorites") || "[]");

  isLoading: boolean = false;

  constructor() {
    makeAutoObservable(this);
  }

  async getOrders() {
    const { data } = await http.get<OrdersResponse>("api/order/my");

    runInAction(() => {
      this.orders = data;
    });
  }

  async getFavorites(): Promise<Product[]> {  
    if(appStore.isLoginIn) {
    this.startLoading(); 
      const { data } = await http.patch<Product[]>("api/favorites",
       {
          city: appStore.selectedCity || "",
          products: JSON.parse(localStorage.getItem('favorites') || '[]'),
        }
      );
      console.log(data);
      
      runInAction(() => {
        this.favorites = data;
      });
      this.finishLoading();
      console.log(this.favorites);
      
      return this.favorites || []; 
    } else {
    return this.favorites || [];
    } 
  }

  get favoritesInfo(): Product[] {
  
    const favorites = JSON.parse(localStorage.getItem("favorites") || JSON.stringify(this.favorites));

    runInAction(() => {
      this.favorites = favorites;
    })
    
    return this.favorites || [];
  }

  async addToFavorite(product: Product) {
    const favorites = await this.getFavorites();
    favorites.push(product);
    localStorage.setItem("favorites", JSON.stringify(favorites));
    this.favorites = [...favorites];
  }

  async inFavoritesExists(product?: string): Promise<boolean>
  {
    let favorites: Product[] = [];
    if (appStore.isLoginIn) {
    favorites = await this.getFavorites();
    } else {
    favorites = JSON.parse(localStorage.getItem("favorites") || "[]");
    }
    console.log(favorites, favorites.find((i) => i.ref_key === product));
    
    return !!favorites.find((i) => i.ref_key === product);
  }

  async toggleFavorite(product: Product) {
    if(appStore.isLoginIn) {
      await http.post<{ message: string }>(
        "api/favorites",
        {
          product_ref_key: product.ref_key,
        }
      );
    } else {
      const favorites = await this.getFavorites();
      const existingIndex = favorites.findIndex((i: Product) => i.ref_key === product.ref_key);
      if (existingIndex >= 0) {
        // Remove from favorites
        favorites.splice(existingIndex, 1);
      } else {
        // Add to favorites
        favorites.push(product);
      }
      // Update localStorage
      localStorage.setItem("favorites", JSON.stringify(favorites));
      this.favorites = [...favorites];
    }
  }

  async setSettings(formData: IAccountSettings) {
    const { data } = await http.post<IAccountSettingsResponse>(
      "api/user/settings",
      {
        name: formData.name,
        surname: formData.surname,
        ...(formData.email
          ? {
              email: formData.email,
            }
          : {}),
      }
    );

    if (data.new_values) {
      localStorage.setItem("user", JSON.stringify(data.new_values));
    }

    return data;
  }


    startLoading() {
        runInAction(() => {
            this.isLoading = true
        })
    }

    finishLoading() {
        runInAction(() => {
            this.isLoading = false
        })
    }
}

export default new AccountStore();
